import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ProcessCd } from '../../../core/models/context';
import { SessionService } from '../../../core/services/session.service';
import { SessionKeys } from '../../../shared/models/SessionKeys';
import { RouteNames } from '../../../shared/routing/app-routing.constants';
import { HelperService } from '../../../shared/services/helper.service';
import { RouteConstant } from '../../e-sign/e-sign-routing.constant';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {
  constructor(
    public authenticationService: AgAuthenticationService,
    public router: Router,
    public helperService: HelperService,
    public sessionService: SessionService
  ) { }

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | Promise<boolean> {
    if (!this.authenticationService.isAuthenticated) {
      const fullUrl = window.location.href;
      if (fullUrl.includes(`/${RouteConstant.fromConnective}`)) {
        // Extract query params as an object
        const urlObj = new URL(fullUrl);
        const params = Object.fromEntries(urlObj.searchParams.entries());
        // Pass the params as additional state to login
        return this.authenticationService.login(this.sessionService.getAuthConfig(), true, params);
      }
      else if (this.helperService.isPageReload()) {
        const fullUrl = window.location.href;
        const pathname = new URL(fullUrl).pathname;
        const currentRouteURL = pathname.replace(/^\/easyinvest/, '');
        this.helperService.createSession(SessionKeys.isPageReload, 'true');
        this.sessionService.updateProcessCd(ProcessCd.DirectLogin);
        this.sessionService.authenticate(true, currentRouteURL);
      } else {
        void this.router.navigate(['/' + RouteNames.authentication + '/' + RouteNames.logout]);
      }
      return false;
    }
    // this.sessionService.setContext(Brand.Uppie, './assets/images/logo-aginsurance.svg');
    return true;
  }
}
